import Webcam from 'react-webcam';
import PhotoTimePreview from './PhotoTimePreview';
import { shallowEqual, useSelector } from 'react-redux';

import countdown1 from './Countdown-1_2x.png';
import countdown2 from './Countdown-2_2x.png';
import countdown3 from './Countdown-3_2x.png';
import MediaService from '../../../services/MediaService';

import './PhotoTimeCamera.scss';
import { useState } from 'react';

const PhotoTimeCamera = ({
  text,
  background,
  dataUri,
  countdown,
  onCameraClick,
  onConfirmPreview,
  onCancelPreview,
}) => {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const countdownList = [countdown1, countdown1, countdown2, countdown3];
  const [showButton, setShowButton] = useState(true);

  const cameraIcon = MediaService.getImage('/Images/Camera_4x.png', login);

  // Photos must be 391 x 580 pixels to work with the iPad version
  const videoConstraints = { width: 391, height: 580 };

  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  return (
    <div
      className='camera-wrapper'
      style={{ backgroundImage: `url(${background})` }}
    >
      <main>
        <div className='camera-title'>
          <h3>{text}</h3>
        </div>

        {dataUri ? (
          <PhotoTimePreview
            dataUri={dataUri}
            onConfirmPreview={() => {
              setShowButton(true);
              onConfirmPreview();
            }}
            onCancelPreview={() => {
              setShowButton(true);
              onCancelPreview();
            }}
          />
        ) : (
          <Webcam
            className='webcam'
            audio={false}
            screenshotFormat='image/jpeg'
            videoConstraints={isIOS() ? {height: 391, width: 580} : videoConstraints}
          >
            {(webCamEvent) =>
              showButton && (
                <button
                  className='photo'
                  onClick={(event) => {
                    setShowButton(false);
                    onCameraClick({ event, webCamEvent });
                  }}
                >
                  <img src={cameraIcon} alt='camera icon' />
                </button>
              )
            }
          </Webcam>
        )}
      </main>
      {countdownList[countdown] && <img alt='countdown' className='photo-countdown' src={countdownList[countdown]} />}
    </div>
  );
};

export default PhotoTimeCamera;
